export const getCompanyId = () => {
  return localStorage.getItem('companyId');
};

export const setCompanyId = (id) => {
  if (id) {
    localStorage.setItem('companyId', id);
  } else {
    localStorage.removeItem('companyId');
  }
};

export const getCampaignCode = () => {
  return localStorage.getItem('campaignCode');
};

export const setCampaignCode = (code) => {
  if (code) {
    localStorage.setItem('campaignCode', code);
  } else {
    localStorage.removeItem('campaignCode');
  }
};
